import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:col-span-2 bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-5" }
const _hoisted_2 = { class: "flex items-center justify-between pb-3 border-b border-divider" }
const _hoisted_3 = { class: "text-base sm:text-lg font-bold text-brown flex items-center gap-2" }
const _hoisted_4 = { class: "text-xs px-2.5 py-1 bg-secondary rounded-lg text-alternative-gray border border-divider" }
const _hoisted_5 = { class: "p-4 rounded-xl border border-success/30 bg-[#F9FCFA]" }
const _hoisted_6 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_7 = { class: "font-bold text-brown text-sm" }
const _hoisted_8 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-2.5"
}
const _hoisted_9 = { class: "p-4 rounded-xl border border-error/30 bg-[#FDF7F7]" }
const _hoisted_10 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_11 = { class: "font-bold text-brown text-sm" }
const _hoisted_12 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-2.5" }

import { computed } from "vue";
import { FavorableDayReport } from "@/types/calculators";
import { useI18n } from "vue-i18n";
import UnexistGoodDoingComponent from "@/views/Calculators/PersonalDates/components/dayReport/UnexistGoodDoingComponent.vue";
import DoingCardComponent from "@/views/Calculators/PersonalDates/components/dayReport/DoingCardComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayDoingsComponent',
  props: {
    dayDetailsInfo: {},
    activityScope: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const isDayHasUnexistGoodDoings = computed(() => {
  return (
    props.dayDetailsInfo.day_report.general.yi_ji_activities.yi.length === 0 &&
    props.dayDetailsInfo.day_report.general.yi_ji_activities.ji.length > 0 &&
    props.dayDetailsInfo.day_report.general.yi_ji_activities.ji[0].name ===
      "诸事不宜"
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.doings-title")), 1),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-xs font-normal text-muted font-caudex" }, " (宜忌指南) ", -1))
        ])
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.activityScope), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "w-6 h-6 rounded-full bg-success text-white flex items-center justify-center text-xs font-bold font-caudex" }, " 宜 ", -1)),
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.favorable-doings")), 1)
      ]),
      (isDayHasUnexistGoodDoings.value)
        ? (_openBlock(), _createBlock(UnexistGoodDoingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayDetailsInfo.day_report.general.yi_ji_activities.yi, (doing) => {
              return (_openBlock(), _createBlock(DoingCardComponent, {
                activity: doing,
                isPositive: true,
                key: doing.code
              }, null, 8, ["activity"]))
            }), 128))
          ]))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "w-6 h-6 rounded-full bg-error text-white flex items-center justify-center text-xs font-bold font-caudex" }, " 忌 ", -1)),
        _createElementVNode("h3", _hoisted_11, _toDisplayString(_unref(t)("calculators.personal-date.full-day-report.unfavorable-doings")), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayDetailsInfo.day_report.general.yi_ji_activities.ji, (doing) => {
          return (_openBlock(), _createBlock(DoingCardComponent, {
            activity: doing,
            isPositive: false,
            key: doing.code
          }, null, 8, ["activity"]))
        }), 128))
      ])
    ])
  ]))
}
}

})